import React, { Component } from 'react';
import './UniversalDropDown.css';
import FontIcon from '../fontIcon/FontIcon';
import Validation from '../validation/Validation';
import models from '../../model/models';
import mainAPI from '../../api/MainAPI';
import Input from '../../inputs/input/Input';
import fuzzysort from 'fuzzysort';
import objUtils from '../../utils/objUtils';
import Label from '../label/Label';
import toasts from '../../utils/toasts';
import utils from '../../utils/utils';
import cloneDeep from 'lodash.clonedeep';

export default class UniversalDropDown extends Component {
	constructor(props) {
		super(props);
		let value = this._defaultValue();
		let search = '';
		if (this.props.options) search = this.getSearch(this.props.options[value]);
		this.state = {
			options: this.props.options,
			value,
			search,
			valid: true,
			open: false,
			initialized: false
		};

		if (this.props.model) {
			this.state.options = models[this.props.model].objs();
		}
		this.state.options = this._formatOptions(this.state.options);
		this.state.filteredOptions = this.state.options;
	}

	componentDidMount = async () => {
		document.addEventListener('mousedown', this._checkForOutsideClick, false);
		document.addEventListener('touchstart', this._checkForOutsideClick, false);
		if (!this.props.src && !this.props.endpoint && !this.props.model) return;
		await this._setOptions();
		if (this.props.subscribeTo) {
			this.subId = models[this.props.subscribeTo].onChange(this._setOptions);
		}
	};

	componentWillUnmount() {
		document.removeEventListener('mousedown', this._checkForOutsideClick, false);
		document.removeEventListener('touchstart', this._checkForOutsideClick, false);

		if (this.props.subscribeTo) {
			models[this.props.subscribeTo].unsubscribe(this.subId);
		}
	}

	componentWillReceiveProps = (nextProps) => {
		let newState = {};
		if (nextProps.value !== this.state.value && nextProps.value !== undefined) {
			let search = this.state.search;
			if (this.state.options) {
				search = this.getSearch(this._getSelected(nextProps.value));
			}
			newState.value = nextProps.value;
			newState.search = search;
		}
		if (!this.state.filteredOptions || utils.isEmptyObject(this.state.filteredOptions)) {
			newState.options = this._formatOptions(nextProps.options);
			newState.filteredOptions = newState.options;
		}
		this.setState(newState);
	};

	_setOptions = async () => {
		let options = await this._getOptionsFromUrl();
		if (!options) options = this._getOptionsFromModel();
		if (options) {
			options = this._formatOptions(options);
			let search = this.getSearch(this._getSelected(this.state.value, options));
			this.setState({ options, filteredOptions: options, search, initialized: true });
		}
	};

	_checkForOutsideClick = (e) => {
		if (!this.element.contains(e.target)) {
			if (this.state.open) this._toggleOpen();
			if (this.props.onBlur) this.props.onBlur();
		}
	};

	isValid = () => {
		let hasValue = false;
		if (this.state) {
			hasValue = !this._isEmpty(this.state.value);
		}
		let required = this.props.required;
		if (required && hasValue) {
			return true;
		} else if (!required) {
			return true;
		} else {
			this.setState({ valid: false });
			return false;
		}
	};

	_defaultValue = () => {
		if (this._isEmpty(this.props.value)) {
			return -1;
		}
		return this.props.value;
	};

	_isEmpty = (value) => {
		if (value === null) return true;
		if (value === undefined) return true;
		if (value === '') return true;
		if (value === -1) return true;
		return false;
	};

	_getOptionsFromUrl = async () => {
		let options = null;
		if (this.props.src) {
			let table = this.props.src.split('-')[0];
			let column = this.props.src.split('-')[1];
			options = await mainAPI.enum.get({table, column});
		} else if (this.state.initialized) {
			options = this.state.options;
		} else if (this.props.endpoint && !this.state.initialized) {
			options = await this.props.endpoint();
		}
		if (this.props.options) {
			if (!options) options = {};
			for (let i in this.props.options) {
				options[i] = this.props.options[i];
			}
		}
		return options;
	};

	_getOptionsFromModel = () => {
		if (!this.props.model) return;
		return models[this.props.model].objs();
	};

	_getDisplayValue = (value) => {
		let displayValue = '';
		let label = this.props.label;
		if (label) {
			if (Array.isArray(label)) {
				for (let i in label) {
					displayValue += value[label[i]] + ' ';
				}
			} else {
				displayValue = value[label];
			}
		} else {
			displayValue = value.name;
		}
		return displayValue;
	};

	_formatOptions = (options) => {
		const newOptions = {};
		for (let i in options) {
			newOptions[i] = cloneDeep(options[i]);
			if (options[i].hasOwnProperty('_search_value')) continue;
			if (typeof options[i] === 'string' ) {
				newOptions[i] = { value: options[i], _search_value: options[i], id: i };
			} else {
				newOptions[i]._search_value = options[i].name;
			}
		}
		return newOptions;
	};

	getValue = () => {
		return this.state.value;
	};

	onChange = (value) => {
		this._toggleOpen(value, () => {
			if (this.props.onChange) this.props.onChange(value);
			if (this.props.onBlur) this.props.onBlur();
		});
	};

	_renderInvalidText = () => {
		if (!this.state.valid) {
			return <Validation />;
		}
	};

	_toggleOpen = (value, callback) => {
		let newState = {};
		newState.open = !this.state.open;
		if (this.props.disabled && !this.state.open) {
			return toasts.show('disabled');
		}
		if (value) newState.value = value;
		this._setOptions();

		if (newState.open) return this._showOptions();
		newState.search = this.state.search;
		if (this.state.options) {
			newState.search = this.getSearch(this._getSelected(value || this.state.value));
		}
		this.setState(newState, callback);
	};

	_classes = () => {
		let classes = 'g-universal-drop-down  ' + (this.props.className || '');
		if (this.state.open) classes += ' open ';
		return classes;
	};
	_getSelected = (value, options) => {
		if (!options) {
			options = this.state.options;
		}
		for (let i in options) {
			let option = options[i];
			let key = option.id || option.value;
			if (key == value) {
				return option;
			}
		}
		return {};
	};

	// canSelectWithTab = () => {
	// 	// if(this.state.open){
	// 	// 	return 0;
	// 	// }
	// 	// else{
	// 	// 	return -1;
	// 	// }
	// 	const otherProps = {}
	// 	if(this.state.open){

	// 	}
	// }

	_showOptions = () => {
		if (this.state.open) return;
		if (this.props.disabled) return toasts.show('disabled');
		let filteredOptions = this._filteredOptions('');
		this.setState({ open: true, search: '', filteredOptions });
	};

	_handleSearchChange = (search) => {
		let filteredOptions = this._filteredOptions(search);
		this.setState({ filteredOptions, search, open: true });
	};

	_filteredOptions = (search) => {
		if (!search) return this.state.options;
		let filteredOptions = fuzzysort.go(search, objUtils.to_array(this.state.options), { key: '_search_value' });
		let returnOptions = {};
		for (let i in filteredOptions) {
			let option = filteredOptions[i];
			if (!option || !option.obj) continue;
			returnOptions[option.obj.id] = option.obj;
		}
		return returnOptions;
	};

	_renderSelected = () => {
		// const otherProps = {}
		// if(this.state.open){
		// 	otherProps.tabIndex = "0";
		// }
    let placeholder = this.props.persistantLabel ? '' : this.props.placeholder;
		return (
			<Label  black-light autosize className="input-placeholder" 
			// onClick={this._showOptions}
			>
				{this.state.search || placeholder}
			</Label>
		);
	};

	_renderOptions = () => {
		
		let opt = [];
		for (let i in this.state.filteredOptions) {
			let val = this.state.filteredOptions[i];
			if (val && val.value) {
				val = val.value;
			}
			let display = val;
			let key = i;
			if (val && val.id) {
				key = val.id;
			}
			if (val && typeof val === 'object' && 'name' in val) {
        display = val.name;
      }
			let isSelected = this.state.value == key;
			opt.push(this._addOption(key, isSelected, display));
		}
		let input = null;
		if (!this.props.noSearch) {
			input = (
				<Input 
					iconName="icon-search"
					value={this.state.search}
					onChange={this._handleSearchChange}
					placeholder="Search"
				/>
			);
		}


		return (
			<div className="options">
				{input}
				<div className="option-scroll-container">{opt}</div>
			</div>
		);
	};

	_addOption = (key, isSelected, display) => {
		let selected = isSelected ? 'selected' : '';
		const otherProps = {}
		if(this.state.open){
			otherProps.tabIndex = "0";
		}
		return (
			<div
				{...otherProps}
				key={key}
				className={selected}
				onClick={(value) => {
					this.onChange(key, value);
				}}
			>
				<Label black-light medium-small>
					{this.props.onRenderOption? this.props.onRenderOption(display) :display}
				</Label>
			</div>
		);
	};

	getSearch = (value) => {
		if (!value) return '';
		let search = value.value || value.name || value;
		if (typeof search !== 'string') search = '';
		return search;
	};
  closeOnEscape = (e) => {
     if(e.key === 'Escape'){
       e.preventDefault();
       this.setState({...this.state,open:false})
     }
  };

	render() {
		const {onClick: onClickDelegate = () => {}} = this.props;
		return (
			<div tabIndex="0" onKeyDown={this.closeOnEscape} ref={(ref) => (this.element = ref)} className={this._classes()} onClick={(event) => {
				onClickDelegate(event);
				this._showOptions();
			}}>
        {this.props.persistantLabel && <Label className={'persistent-label'}>{this.props.placeholder}</Label>}
				{this._renderSelected()}
				{this._renderOptions()}
				<FontIcon name="icon-chevron-right" />
				{this._renderInvalidText()}
			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/components/universalDropDown/UniversalDropDown.jsx